import { useQuery } from "urql";

import { GetCurrentUserDocument } from "../../../graphql/generated.ts";

export function useCurrentUser() {
  return useQuery({ query: GetCurrentUserDocument });
}
